var render, staticRenderFns
import script from "./AuthRegisterPage.vue?vue&type=script&lang=js"
export * from "./AuthRegisterPage.vue?vue&type=script&lang=js"
import style0 from "./AuthRegisterPage.vue?vue&type=style&index=0&id=40090e7a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports